import type { BespokeTemplateResponse } from '../../services/api/types.gen';
import type { SectionEditorDraft } from '../../store/slices/formSchemaEditorSlice';
import type { VibecoderDraft } from './formSchemaTypes';

/** What the inline section editor is currently pointed at. */
export interface EditorTarget {
  editingTemplate: BespokeTemplateResponse | null;
  draft: VibecoderDraft | null;
}

export function blankEditorTargetFromDraft(
  draft: SectionEditorDraft
): EditorTarget {
  return {
    editingTemplate: null,
    draft: {
      schemaVersionName: draft.schemaVersionName,
      schemaVersionValue: draft.schemaVersionValue,
      rogerDocFormType: draft.rogerDocFormType,
      sectionName: draft.sectionName,
      name: draft.name,
      description: draft.description,
      layoutJsonText: draft.layoutJsonText,
      layoutStatus: draft.status,
    },
  };
}

export function editorTargetFromPersistedDraft(
  draft: SectionEditorDraft,
  templates: BespokeTemplateResponse[]
): EditorTarget {
  if (draft.editingTemplateId) {
    const template = templates.find(t => t.id === draft.editingTemplateId);
    if (template) {
      return { editingTemplate: template, draft: null };
    }
  }
  return blankEditorTargetFromDraft(draft);
}
